export default __webpack_public_path__ + "static/media/menu-icon.2ed9c710.svg";